import { ListingRef } from './listing'
import { Charger } from './charger'
import { DropdownOption } from './option'

export const connectorStatus = [
  'Available',
  'Charging',
  'Preparing',
  'Finishing',
  'SuspendedEV',
  'SuspendedEVSE',
  'Faulted',
  'Unavailable',
  'Offline',
] as const

export const listingServiceStatusesDefault = [
  'active',
  'on_hold',
  'property_activating',
  'driver_activating',
  'awaiting_commissioning',
  'commissioned',
  'testing',
  'troubleshooting',
  'under_repair',
]

export const listingServiceStatus = [
  'awaiting_commissioning',
  'commissioned',
  'decommissioned',
  'property_activating',
  'driver_activating',
  'troubleshooting',
  'under_repair',
  'active',
  'testing',
]

export const connectorServiceStatus = [...listingServiceStatusesDefault, 'decommissioned', 'other', 'terminated']

export const connectorType = [
  'J3400',
  'J1772',
  'CCS',
  'CHAdeMO',
  'Tesla',
  'Type 2',
  'Type 1',
  'Type 3',
  'GB/T',
  'Other',
] as const

export type ConnectorType = typeof connectorType[number]
export type ConnectorStatus = typeof connectorStatus[number]
export type ConnectorServiceStatus = typeof connectorServiceStatus[number]
export type ListingServiceStatus = typeof listingServiceStatus[number]

export const ConnectorStatusAlias: { [key: string]: ConnectorStatus[] } = {
  available: ['Available'],
  inuse: ['Charging', 'Preparing', 'Finishing', 'SuspendedEV', 'SuspendedEVSE'],
  unavailable: ['Unavailable', 'Faulted'],
  active: ['Available', 'Charging', 'Preparing', 'Finishing', 'SuspendedEV', 'SuspendedEVSE', 'Unavailable', 'Faulted'],
  offline: ['Offline'],
  online: ['Available', 'Charging', 'Preparing', 'Finishing', 'SuspendedEV', 'SuspendedEVSE'],
}

export const ConnectorServiceStatusAlias: { [key: string]: ConnectorServiceStatus[] } = {
  underRepair: ['under_repair'],
  troubleshooting: ['troubleshooting'],
  activating: ['property_activating', 'driver_activating', 'commissioned'],
  commissioning: ['on_hold', 'awaiting_commissioning', 'troubleshooting'],
  active: ['active', 'troubleshooting'],
  repairing: ['under_repair', 'other', 'troubleshooting'],
}

export interface DropdownServiceStatusOptions {
  under_repair: DropdownOption[]
  decommissioned: DropdownOption[]
  active: DropdownOption[]
}

export interface ConnectorRef {
  id: number
  connectorId: number
  serviceStatus?: ConnectorServiceStatus
}

export interface Connector extends ConnectorRef {
  state: ConnectorStatus
  charger?: Charger
  listing?: ListingRef
  lastStatusChangedAt: string
}

export interface ConnectorLog {
  message: string
  success: boolean
  createdAt: string
  errorCode: string
  vendorErrorCode: string
}

export interface ConnectorV2 extends ConnectorRef {
  serviceStatus?: ConnectorServiceStatus
  ocppStatus?: ConnectorStatus
  connectorType?: ConnectorType
  lastStatusChangedAt?: string | null
}
